const { CountryOfOperationItems } = require('../utils/constants');

/* eslint-disable indent */
const getFrontSnippetPlaceholder = (formData, finalPaymentMethods, finalPaymentTypes) => `
  <html>
  <head>
    <script src="https://sdk.mercadopago.com/js/v2"></script>
  </head>
  <body>
    <div className={"brand-brick-form__main-container"}>
      <div className="brand-brick-form__button-container">
        <div id="brandBrick_container" />
      </div>
      <div className="brand-brick-form__white-field" />
      <div className="brand-brick-form__white-field" />
      <div className="brand-brick-form__two-columns">
        <div className="brand-brick-form__white-field" />
        <div className="brand-brick-form__divisor" />
        <div className="brand-brick-form__white-field" />
      </div>
    </div>
    <script>
      const mp = new MercadoPago('YOUR_PUBLIC_KEY', {
        locale: '${CountryOfOperationItems.getFormatedLanguageByCountry(formData.publicKey, formData.language)}'
      });
      const bricksBuilder = mp.bricks();
      const renderBrandBrick = async (bricksBuilder) => {
        const settings = {
          customization: {
            texts: {
              valueProp: '${formData?.valueProp || 'payment_methods'}',
              align: '${formData?.align || 'left'}',
              useCustomFont: ${formData?.useCustomFont || false},
              size: '${formData?.size || 'medium'}',
              fontWeight: '${formData?.fontWeight || 'semibold'}',
              color: '${formData?.color || 'secondary'}',
            },
            paymentMethods: {
              excludedPaymentMethods: ${finalPaymentMethods},
              excludedPaymentTypes: [${finalPaymentTypes.map((item) => `'${item}'`)}],
              maxInstallments: ${formData?.maxInstallments || 12},
              interestFreeInstallments: ${formData?.interestFreeInstallments || false},
            },
            visual: {
              backgroundColor: '${formData?.backgroundColor || 'white'}', 
              hideMercadoPagoLogo: ${!formData?.showMercadoPagoLogo || false},
              border: ${formData?.border || false},
              borderColor: '${formData?.borderColor || 'dark'}',
              contentAlign: '${formData?.contentAlign || 'center'}',
              borderWidth: '${formData?.borderWidth || 1}px',
              borderRadius: '${formData?.borderRadius || 0}px',
              verticalPadding: '${formData?.verticalPadding || 8}px',
              horizontalPadding: '${formData?.horizontalPadding || 16}px',
            },
          },
        };
        window.brandBrickController = await bricksBuilder.create('brand', 'brandBrick_container', settings);
      };
      renderBrandBrick(bricksBuilder);
    </script>
  </body>
  </html>
  `;

module.exports = { getFrontSnippetPlaceholder };
